// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueImg from 'v-img'
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueAnalytics from 'vue-analytics'


Vue.config.productionTip = false

const vueImgConfig = {
  // Use `alt` attribute as gallery slide title
  altAsTitle: true,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: true,
  // Event listener to open gallery will be applied to <img> element
  openOn: 'click',
  // Show thumbnails for all groups with more than 1 image
  thumbnails: true
};

Vue.use(VueImg, vueImgConfig)
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)
Vue.use(VueAnalytics, {
  id: 'UA-167550571-1',
  autoTracking: {
    screenview: true
  },
  debug: {
    sendHitTask: true,
    enabled: false,
    trace: true
  }
})

/* eslint-disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js